import { FieldType } from "@shared/features/form/Form";

export const makeFormFields = (fieldNames: string[]): FieldType[] => {
  const fields = {
    firstName: {
      name: "firstName",
      label: "First Name",
      placeholder: "Enter your first name",
      component: "Input",
      required: true,
    },
    lastName: {
      name: "lastName",
      label: "Last Name",
      placeholder: "Enter your last name",
      component: "Input",
      required: true,
    },
    email: {
      name: "email",
      label: "Email",
      placeholder: "Enter your email",
      component: "Input",
      autoComplete: "username",
      required: true,
    },
    confirmEmail: {
      name: "confirmEmail",
      label: "Email Confirmation",
      placeholder: "Confirm your email",
      component: "Input",
      required: true,
    },
    currentPassword: {
      name: "currentPassword",
      label: "Current Password",
      placeholder: "Enter your current password",
      component: "Input",
      type: "password",
      autoComplete: "current-password",
      required: true,
      isHideErrorMessage: false,
    },
    password: {
      name: "password",
      label: "Password",
      placeholder: "Enter your password",
      component: "Input",
      type: "password",
      required: true,
      isHideErrorMessage: true,
    },
    confirmPassword: {
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm your password",
      component: "Input",
      type: "password",
      required: true,
      isHideErrorMessage: false,
    },
    organization: {
      name: "organization",
      label: "Organization",
      placeholder: "Enter your organization name",
      component: "Input",
      required: true,
    },
    organizations: {
      name: "organizations",
      label: "Alumni Affiliations",
      placeholder:
        "What BFA / MFA / residencies / fellowships / art programs have you participated in?",
      component: "Textarea",
      required: true,
    },
    message: {
      name: "message",
      label: "Message",
      placeholder: "Your message",
      component: "Textarea",
      required: false,
    },
    photo: {
      name: "photo",
      label: "Photo",
      placeholder: "Upload your photo",
      component: "PhotoUploadInput",
      required: false,
    },
    pronouns: {
      name: "pronouns",
      label: "Pronouns",
      placeholder: "Your pronouns",
      component: "Input",
      required: false,
    },
    website: {
      name: "website",
      label: "Website",
      placeholder: "https://yourwebsite.com",
      component: "Input",
      required: false,
    },
    bio: {
      name: "bio",
      label: "Bio",
      placeholder: "Enter a short bui",
      component: "Textarea",
      required: false,
    },
    timezone: {
      name: "timezone",
      label: "Timezone",
      placeholder: "Select your timezone",
      component: "TimezoneSelect",
      required: true,
    },
    cv: {
      name: "cv",
      label: "CV",
      placeholder: "Upload your CV",
      component: "ResumeUploadInput",
      required: false,
    },
    isEmailNotificationsEnabled: {
      name: "isEmailNotificationsEnabled",
      label: "Receive System Notifications Via Email",
      component: "Checkbox",
      required: true,
    },
  } as const;

  type FieldName = keyof typeof fields;

  return fieldNames.map((name) => fields[name as FieldName]) as FieldType[];
};

export default makeFormFields;
